import { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../store";
import { findUserTokenInStorage } from "../../../store/auth/authActions";
import authInterceptor from "../../../api/authInterceptor";

export default function useAuth() {
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const userToken = useSelector(
    (state: State) => state.auth.userToken,
    (oldToken, newToken) => oldToken.sessionToken === newToken.sessionToken
  );
  const isLoggedIn = useSelector((state: State) => state.auth.isLoggedIn);

  useLayoutEffect(() => {
    dispatch(findUserTokenInStorage());
  }, [dispatch]);

  useLayoutEffect(() => {
    authInterceptor(userToken.sessionToken);
    setLoading(false);
  }, [userToken]);

  return { isLoggedIn, loading };
}
